import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Button, Table, Tooltip } from "antd";
import { useModel } from "../../../models";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const columns = [
    {
        title: '序号',
        width: 50,
        align: "center",
        render: (_, __, index) => <span>{index + 1}</span>,
    },

    {
        title: '销售单号',
        width: 150,
        dataIndex: 'saleCode',
    },
    {
        title: '日期',
        width: 150,
        dataIndex: 'createTime',
        align: 'left',
    },
    {
        title: '商品编号',
        width: 120,
        dataIndex: 'materialCode',
    },
    {
        title: '商品名称',
        width: 150,
        dataIndex: 'materialName',
        ellipsis: true,
        render: (text) => (<Tooltip title={text}>{text}</Tooltip>)
    },
    {
        title: '商品类型',
        width: 120,
        dataIndex: 'categoryName',
    },

    {
        title: '单价',
        width: 100,
        dataIndex: 'salePrice',
    },
    {
        title: '销售数量',
        width: 120,
        dataIndex: 'saleNum',
    },
    {
        title: '销售金额',
        width: 80,
        dataIndex: 'aggregateAmount',
    },
    {
        title: '退货数量',
        width: 80,
        dataIndex: 'returnNum',
    },
    {
        title: '已出库数量',
        width: 100,
        dataIndex: 'issuedNum',
    },
    {
        title: '未出库数量',
        width: 100,
        dataIndex: 'noIssuedNum',
    },
    {
        title: '成本价',
        width: 100,
        dataIndex: 'costPrice',
    },
    {
        title: '销售成本',
        width: 100,
        dataIndex: 'saleCost',
    },
    {
        title: '销售毛利',
        width: 100,
        dataIndex: 'saleProfit',
    },
    {
        title: '客户名称',
        width: 250,
        dataIndex: 'customerName',
        ellipsis: true,
        render: (text) => (<Tooltip title={text}>{text}</Tooltip>)
    },
    {
        title: '客户编号',
        width: 140,
        dataIndex: 'customerCode',
    },
    {
        title: '联系人',
        width: 100,
        dataIndex: 'customerPerson',
    },
    {
        title: '联系电话',
        width: 100,
        dataIndex: 'customerPhone',
    },
    {
        title: '备注',
        width: 150,
        dataIndex: 'saleDesc',
        ellipsis: true,
        render: (text) => (<Tooltip title={text}>{text}</Tooltip>)
    }
];


export default function () {
    const [{ searchParam, partOrCustomerList, partOrCustomerStatistics, searchPage }, { loadListDetail, exportPartDealList }] = useModel("partOrCustomerModel");
    // useEffect(() => {
    //     const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
    //     const { pageSize, pageNum } = searchPage
    //     let data = {
    //         ...searchParam,
    //         startTime,
    //         endTime,
    //         pageSize,
    //         pageNum,
    //     }
    //     loadListDetail({ showMsg: true, data })
    // }, []);

    const history = useHistory();

    const onExport = () => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        let data = {
            ...searchParam,
            startTime,
            endTime,
        }
        exportPartDealList({ showMsg: true, data });
    }

    const TableHeader = () => {
        return (
            <div style={{ margin: "0 0 8px", display: "flex" }}>
                <div style={{ width: "460px", paddingTop: "6px" }}>
                    <YhAuth resCode={ResourceAuthEnum.STTICS_MC_EX}>
                        <Button className="margin-left-8" onClick={onExport}>导出</Button>
                    </YhAuth>
                </div>
                <div className="detail-list-statistic color-primary" style={{ textAlign: "right" }}>
                    <span
                        className="margin-left-8">
                        总销量：{!!partOrCustomerStatistics ? partOrCustomerStatistics.saleNumTotal : 0}
                    </span>
                    <span
                        className="margin-left-16">
                        销售总金额：{!!partOrCustomerStatistics ? partOrCustomerStatistics.aggregateAmountTotal : 0}
                    </span>
                    <span
                        className="margin-left-16">
                        销售总成本：{!!partOrCustomerStatistics ? partOrCustomerStatistics.productionCost : 0}
                    </span>
                    <span
                        className="margin-left-16">
                        销售总毛利：{!!partOrCustomerStatistics ? partOrCustomerStatistics.grossProfit : 0}
                    </span>
                </div>
            </div>
        )
    }

    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={partOrCustomerList}
                bordered
                pagination={{
                    hideOnSinglePage: false,
                    showSizeChanger: true,
                    pageSizeOptions: [15, 50, 100, 200, 500],
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: (pageNum, pageSize) => {
                        /*const params = {...searchParam};
                        params.pageNum = pageNum;
                        params.pageSize = pageSize;*/
                        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
                        const { materialCode, customerName, categorys, materialName, customerType, saleCode } = searchParam;
                        const data = {
                            materialCode, customerName, categorys, materialName, customerType, saleCode,
                            startTime, endTime, pageNum, pageSize
                        }
                        loadListDetail({ showMsg: false, data });
                    },
                    total: searchPage.total,
                    current: searchPage.pageNum,
                }}
                // onRow={record => {
                //     return {
                //         onClick: event => {
                //             if (partDealListSelectedRowKeys
                //                 && partDealListSelectedRowKeys[0]
                //                 && partDealListSelectedRowKeys[0] === record.key) {
                //                 setPartDealListSelectedRowKeys([]);
                //             } else {
                //                 setPartDealListSelectedRowKeys([record.key]);
                //             }
                //         },
                //     };
                // }}
                // rowSelection={{
                //     type: "radio",
                //     onChange: (selectedRowKeys) => {
                //         setPartDealListSelectedRowKeys(selectedRowKeys)
                //     },
                //     selectedRowKeys: partDealListSelectedRowKeys
                // }}
                scroll={{ x: 'max-content', y: 2000 }}
            />
        </>
    );
}